/* eslint-disable */
import React, {useState} from 'react';
import {getPublicImagePath, notifyError, notifySuccess, useAppDispatch} from '@nutastic/nutastic-react-app';
import {sendReservation} from "../../actions/reservation-actions.mjs";

const componentClass = 'coming-soon-page';

const ComingSoonPage = (onToggleLinksPage) => {
    const dispatch = useAppDispatch();
    const [formStatus, setFormStatus] = useState(0);
    const [formValue, setFormValue] = useState({
        firstname: '',
        lastname: '',
        email: '',
        isTeamCaptain: false,
        teamName: '',
        teamPlayers: ''
    });

    const onValueChange = (e, key) => {
        const updatedValue = e.target.value;
        setFormValue({
            ...formValue,
            [key]: updatedValue
        });
        if (formStatus !== 1) {
            setFormStatus(0);
        }
    };

    const onCheckboxChange = (e, key) => {
        setFormValue({
            ...formValue,
            [key]: event.target.checked
        });
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        if (formValue.firstname && formValue.lastname && formValue.email) {
            dispatch(sendReservation(formValue));
            setFormStatus(1);
            setFormValue({
                firstname: '',
                lastname: '',
                email: '',
                isTeamCaptain: false,
                teamName: '',
                teamPlayers: ''
            });
            notifySuccess("Thank you for registering for the 2025 Season, let's get it!");
        } else {
            notifyError(null, null, 'Your full name and a valid email are required to make a reservation.');
        }
    };

    return <React.Fragment>
        <div className={`${componentClass}__content`}>
            <img src={getPublicImagePath('emblem-logo.png')} alt='Crew League' className={`${componentClass}__logo`}/>
            <div className={`${componentClass}__form`}>
                <h5>Registration is closed for the 2025 season. If you registered, please make sure you make your payment by March 22, 2025 to secure your spot for the season. Click the dollar icon in the top right to make payment.<br /><br />$60 - <i>Single Player Registration</i> • $500 - <i>Team Registration (8-12 Players)</i></h5>
                <form onSubmit={onFormSubmit} className="form-content reservation-form d-none">
                    <div className="form-group">
                        <label>First Name:</label>
                        <input type="text" name="name" value={formValue.firstname} onChange={e => onValueChange(e, 'firstname')} className="form-control" placeholder="First Name"/>
                    </div>
                    <div className="form-group">
                        <label>Last Name:</label>
                        <input type="text" name="name" value={formValue.lastname} onChange={e => onValueChange(e, 'lastname')}
                               className="form-control" placeholder="Last Name"/>
                    </div>
                    <div className="form-group">
                        <label>Email:</label>
                        <input type="text" name="email" value={formValue.email} onChange={e => onValueChange(e, 'email')}
                               className="form-control" placeholder="Email"/>
                    </div>
                    <div className="form-group">
                        <input type="checkbox" name="isTeamCaptain" onChange={e => onCheckboxChange(e, 'isTeamCaptain')} checked={formValue.isTeamCaptain}/> <label htmlFor="isTeamCaptain" className="ml-2">Are you registering for a team?</label>
                    </div>
                    { formValue.isTeamCaptain && <div>
                        <div className="form-group">
                            <label>Team Name:</label>
                            <input type="text" name="teamName" value={formValue.teamName} onChange={e => onValueChange(e, 'teamName')} className="form-control" placeholder="Team Name"/>
                        </div>
                        <div className="form-group">
                            <label>Enter your team name and list of team players below:</label>
                            <textarea name="message" value={formValue.teamPlayers} onChange={e => onValueChange(e, 'teamPlayers')} className="form-control" placeholder=""/>
                        </div>
                    </div>}
                    <div className="mt-3">
                        <button type="submit" className="btn btn-white">Submit Registration Form</button>
                    </div>
                    {formStatus === 1 && <p className="mt-5"><b>Thank you for your registering. Make sure to submit full payment or deposit to complete your registration.</b></p>}
                    {formStatus === -1 && <p className="mt-5"><b>Unable to complete your RSVP due to insufficient details (name or email is missing).</b></p>}
                    <small className="mt-5">
                        Single player registrations will be placed on teams at random. Registration is not official until $60 is paid in full.
                        Team registrations require a $250 deposit, you can register 8-12 players. The full $500 must be paid prior to registration closure
                        in order to reserve spot for season.
                    </small>
                </form>
            </div>
        </div>
    </React.Fragment>
};

export default ComingSoonPage;
